/**
 * Decodes a JWT and returns the payload as a JSON object.
 * This function does not verify the signature, it only decodes the payload.
 * @param token The JWT string to decode.
 * @returns The decoded payload as a JSON object.
 */

export function decodeJWT(token: string): any {
  // Split the token into its parts (header, payload, signature)
  const parts = token.split(".");

  if (parts.length !== 3) {
    // This means the token is invalid (should have 3 parts)
    console.error("Invalid JWT Token...");
  }

  // Decode the payload (second part of the JWT)
  const payload = parts[1];

  // Base64url decoding (replace URL-specific chars)
  const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");

  // Decode the base64-encoded payload
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  // Parse the JSON payload
  try {
    return JSON.parse(jsonPayload);
  } catch {
    console.error("Failed to parse JWT payload — malformed token");
    return null;
  }
}

// Function to get expiration time from decoded JWT token and check if it is expired

export function isTokenExpired(token: string): boolean {
  // Decode the token
  const decodedToken = decodeJWT(token);

  // If decoding failed, treat token as expired
  if (!decodedToken) return true;

  // Get the expiration time from the decoded token
  const expirationTime = decodedToken.exp;

  // Get the current time
  const currentTime = Math.floor(Date.now() / 1000);

  // Check if the token is expired
  return expirationTime < currentTime;
}
